module.exports = __webpack_public_path__ + "static/Emma-Moore-638e5fe01a7e6ae5562e65d3f01deade.jpg";